/* eslint-disable @typescript-eslint/naming-convention */

import de from '@/languages/german.json';
import en from '@/languages/english.json';
import { createI18n } from 'vue-i18n';

const messages = {
  de_DE: de,
  en_US: en
};

// Type.define 'de_DE' as the master Schema
type MessageSchema = typeof de;

export const vuei18n = createI18n<[MessageSchema], 'en_US' | 'de_DE'>({
  locale:
    localStorage
      .getItem('currentLang')
      ?.replace('de-DE', 'de_DE')
      .replace('en-GB', 'en_US') || 'de_DE',
  fallbackLocale: 'en_US',
  messages: messages,
  legacy: false
});

export const i18n = vuei18n.global;

export const i18nViteTest = vuei18n;
